<template>
  <div class="recycle-bin-list-container" v-loading="loading">
    <div class="list-header list-item">
      <el-tooltip class="check-all-icon" effect="dark" content="全选" placement="top">
        <el-checkbox
          v-if="batch"
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
        ></el-checkbox>
      </el-tooltip>

      <div class="name col">
        任务清单标题
      </div>
      <div class="user col">
        删除人
      </div>
      <div class="date col">
        操作日期
      </div>
    </div>
    <ul class="task-list" v-infinite-scroll="load">
      <li
        class="list-item"
        v-for="(item, index) of originalList"
        :key="item.task_list_id"
        :class="{'is-batch': batch, 'is-chos': ~chosList.indexOf(item.task_list_id)}"
        :ref="`subItem${item.task_list_id}`"
        @click="handleChos(item.task_list_id, originalList, index)"
      >
        <el-checkbox
          v-if="batch"
          v-model="item.chos"
          @change="handleChos(item.task_list_id, originalList, index)"
        ></el-checkbox>
        <div class="name col">
          <toolTip class="task-name" :title="item.title" :maxWidth="'420px'">
            <span>{{ item.title }}</span>
          </toolTip>
          <div class="recover" @click.stop="handleRecover(item.task_list_id)">
            <i class="icon iconfont iconicon_restore"></i>
            <span>恢复</span>
          </div>
        </div>
        <div class="user col">
          {{ item.delete_user ? item.delete_user.realname : '' }}
          <!-- {{ item.project_dynamics.length ? item.project_dynamics[0].message_sender_user.realname : '' }} -->
        </div>
        <div class="date col">
          {{ getTime(item.delete_time) }}
        </div>
      </li>

      <nothing v-if="!originalList.length"></nothing>

      <div class="loading-box" v-if="isLoading && !finish">
        <i class="el-icon-loading"></i>
      </div>
    </ul>

    <div class="batch-box-wrap" v-if="batch">
      <div class="num">已选中 {{ num }} 项</div>
      <div class="recover batch-item" @click="handleRecover(0)">
        <i class="icon iconfont iconicon_restore"></i>
          <span>恢复</span>
      </div>
      <div class="exit batch-item" @click="handleExit">
        <i class="icon iconfont iconicon_close1"></i>
        <span>退出</span>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api/recycle'
import dayjs from "dayjs"
import { mapMutations } from "vuex";

export default {
  props: {
    projectId: {
      type: Number,
      default: 0
    },
    batch: {
      // 是否进入批量选择状态
      type: Boolean,
      default: false
    }
  },
  computed: {
    num() {
      // 批量选择中选择了多少个项目
      return this.chosList.length
    }
  },
  data() {
    return {
      loading: false,
      originalList: [],
      originalListIdArr: [], // 由所有任务id组成的数组
      list: [],
      per_page: 10,
      page: 0,
      finish: false,
      weekdays: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      isIndeterminate: true,
      checkAll: false,
      chosList: [], // 已选择的列表，由id组成的数组
      isLoading: false
    }
  },
  created() {
    this.load()
  },
  methods: {
    ...mapMutations("task/task", ["SET_ACTIVE", "SET_DATALIST", "CHANGE_TASK"]),
    // 初始化获取列表
    async init () {
      const param = {
        project_id: this.projectId,
        number: this.per_page,
        page: this.page
      }
      const res = await api.getTaskListRecycleBinList(param)
      if (res.data.length < this.per_page) this.finish = true
      this.originalList.push(...res.data)

      this.originalListIdArr = this.originalList.map(item => { return item.task_list_id })

      this.$emit('handleGetList', 'taskListNum', this.originalList.length)

      // if (this.originalList.length && this.page === 1) {
      //   // 首次加载，转换原有的列表
      //   this.changeList(this.originalList) // 将列表转换格式
      // } else if (res.data.length && this.page >= 2) {
      //   // 下拉加载的，将新增加的数据转换进列表
      //   this.changeList(res.data) // 将列表转换格式
      // }
    },
    // 加载更多
    async load() {
      if (this.page && this.originalList.length < 10) return
      if (this.finish) return
      this.isLoading = true
      this.page += 1
      await this.init()
      this.isLoading = false
    },
    changeList(list) {
      list.forEach(item => {
        // 将时间改为 'yyyy年mm月dd日 周x'的格式
        const _weekday = this.weekdays[new Date(item.delete_time).getDay()]
        // const time = dayjs(item.delete_time).format("YYYY/MM/DD hh:mm")
        const time = dayjs(item.delete_time).format("YYYY年MM月DD日") + ' ' + _weekday
        // const time = item.delete_time.split(' ')[0] === dayjs(new Date()).format("YYYY-MM-DD") ? dayjs(new Date()).format("YYYY 今天") : dayjs(item.delete_time).format("YYYY年MM月DD日")

        // 找到列表里面相同时间的，集合到一起，如果不同，则新增进去
        let idx = null
        const fl = this.list.find((item, index) => {
          if (item.time === time) {
            idx = index
            return true
          }
        })
        if (fl) {
          this.list[idx].children.push(item)
        } else {
          this.list.push({
            time,
            children: [item]
          })
        }

      })
    },
    // 全选
    handleCheckAllChange(val) {
      this.isIndeterminate = false
      if (val) {
        // 全选
        this.chosList = []
      } else {
        // 取消全选
        this.chosList = JSON.parse(JSON.stringify(this.originalListIdArr))
      }

      for (let i = 0, len = this.originalList.length; i < len; i++) {
        this.handleChos(this.originalList[i].task_list_id, this.originalList, i)
      }

    },
    // 批量选择时选中
    handleChos(curId, data, index) {
      // console.log(index, data.length, 111)
      if (!this.batch) return
      const _ts = this
      const _index = _ts.chosList.indexOf(curId)
      if (~_index) {
        // 已选择，则取消选择
        _ts.chosList.splice(_index, 1)
        data[index].chos = false
      } else {
        // 未选择，加入选择行列
        _ts.chosList.push(curId)
        data[index].chos = true
      }

      // 判断全选icon是否处于默认状态
      _ts.isIndeterminate = _ts.chosList.length === 0 || _ts.chosList.length === _ts.originalListIdArr.length ? false : true
      // 判断是否全选
      _ts.checkAll = _ts.chosList.length === _ts.originalListIdArr.length ? true : false

      // const prevId = index === 0 ? null : data[index - 1].task_list_id // 获取前一个元素的id
      // const nextId = index === data.length - 1 ? null : data[index + 1].task_list_id // 获取后一个元素的id
      // // console.log(prevId, nextId, 222)
      // // 处理前一个元素
      // if (prevId && ~_ts.chosList.indexOf(prevId)) {
      //   // 前一个元素存在并且已选
      //   if (!~_index) {
      //     // 当前元素选中，需要让前一个元素去掉下边框
      //     _ts.$nextTick(() => {
      //       _ts.$refs[`subItem${prevId}`][0].classList.add('clear-border-b')
      //     })
      //   } else {
      //     // 当前元素取消选中，需要让前一个元素加上下边框，也就是重置类名
      //     _ts.$nextTick(() => {
      //       _ts.$refs[`subItem${prevId}`][0].classList.remove('clear-border-b')
      //     })
      //   }
      // }

      // //处理当前元素
      // if (nextId && ~_ts.chosList.indexOf(nextId)) {
      //   // 后一个元素存在并且已选
      //   if (!~_index) {
      //     // 当前元素选中，需要让其去掉下边框
      //     _ts.$nextTick(() => {
      //       _ts.$refs[`subItem${curId}`][0].classList.add('clear-border-b')
      //     })
      //   } else {
      //     // 当前元素取消选中，需要让其重置类名
      //     _ts.$nextTick(() => {
      //       _ts.$refs[`subItem${curId}`][0].classList.remove('clear-border-b')
      //     })
      //   }
      // }
    },
    // 恢复
    async handleRecover(id) {
      this.$wfAlert('warning', '确认恢复内容吗？', '恢复内容后，内容将恢复至原来位置。', '恢复内容').then(async () => {
        const listarr = id ? [id] : this.chosList
        // console.log(listarr, 11)
        const res = await api.postRestoreTaskLists({ taskListIds: listarr })
        if (res) {
          this.$message({
            message: '恢复任务清单成功',
            type: 'success'
          })
          if (this.batch) {
            this.handleCheckAllChange(false)
            this.$emit('handleExit')
          }
          this.originalList = []
          this.list = []
          this.per_page = this.page * this.per_page
          this.page = 1
          this.init()
        }
      }).catch(() => {
        console.log('执行异常')
        next(false)
      })

    },
    // 退出批量选择模式
    handleExit() {
      this.handleCheckAllChange(false)
      this.$emit('handleExit')
    },
    // 获取操作时间
    getTime(val) {
      return dayjs(val).format("YYYY/MM/DD hh:mm")
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
